<template lang="pug">
  v-container
    base-snackbar(
      :errors.sync="verifyErrors"
    )
    v-row
      v-col.pa-1(cols='12' lg='4')
        v-card.ma-0
          v-toolbar(color='primary' dark='')
            v-card-title
              | Add Transaction
          v-row.mx-2
            //- v-col(cols='12')
            //-   v-alert.py-0.text-uppercase(
            //-     dense=''
            //-     type='error'
            //-     outlined=''
            //-     text=''
            //-     dismissible=''
            //-     transition='slide-x-transition'
            //-     v-if="verifyErrors.errors || verifyErrors.error"
            //-   )
            //-     span {{ verifyErrors[0] }}
            v-col(cols='12')
              v-text-field(label='Receipt No' 
              hide-details="auto" v-model='receiptNo' :error-messages='verifyErrors.receipt_no')
            v-col(cols='12')
              v-autocomplete(
                label='Supplier'
                v-model='supplierId'
                :items='suppliers'
                :search-input.sync='searchInput'
                item-value='id'
                no-filter
                hide-details="auto"
                :error-messages='verifyErrors.supplier_id'
                :loading='supplierFetching || searching'
              )
                template(v-slot:selection='{ item }')
                  | {{ item.id }}
                template(v-slot:item='{ item }')
                  span.blue--text {{ item.id }}
                  span.mx-1
                  small {{ item.name }}
            v-col(cols='12')
              v-autocomplete(
                label='Stock Code'
                :disabled='!supplierId  '
                :items='splrPdList'
                item-value='stock_id'
                :filter='filterSplrPd'
                :loading='splrPdLoading'
                v-model='stockId'
                hide-details="auto"
                :error-messages='verifyErrors.stock_id'
              )
                template(v-slot:selection='{ item }')
                  | {{ item.stock_code }}
                template(v-slot:item='{ item }')
                  span.blue--text {{ item.stock_code }}
                  span.mx-1
                  small {{ item.product_name }} ({{ item.brand_name }})
            v-col(cols='12')
              v-text-field(
                label='Transaction Date'
                type='date'
                :disabled='!supplierId'
                v-model='dateTransaction'
                hide-details="auto"
                :error-messages='verifyErrors.date_transaction'
              )
            v-col(cols='12')
              v-text-field(label='Cost Per Unit' 
              hide-details="auto" prefix='₱' type='number' :disabled='!stockId' v-model.number='cost' :error-messages='verifyErrors.cost')
            v-col(cols='12')
              v-text-field(:disabled='!stockId' 
              hide-details="auto" label='Quantity' type='number' v-model.number='quantity' :error-messages='verifyErrors.quantity')
            v-col(cols='12')
              v-autocomplete(:disabled='!stockId' 
              hide-details="auto" :items='units' label='Unit' v-model='unit' :error-messages='verifyErrors.unit')
            v-col(cols='12')
              v-textarea(label='Notes' auto-grow='' 
              hide-details="auto" no-resize='' v-model='notes' rows='1' :error-messages='verifyErrors.notes')
            v-col(cols='12')
              v-btn(color='green' @click='addTransaction' :loading='verifying')
                | Add Transaction
      v-col.pa-1(cols='12' lg='8')
        v-card.ma-0
          v-toolbar(color='primary' dark='')
            span Unsaved Transactions
            v-spacer
            v-tooltip(bottom='')
              template(v-slot:activator='{ on, attr }')
                v-btn.ma-0(text='' v-bind='attr' v-on='on' :disabled='!tempList.length' @click='initUpload')
                  v-icon mdi-upload
              span Upload Data
          v-alert.py-0.text-uppercase(dense='' type='error' outlined='' text='' dismissible='' transition='slide-x-transition' v-for='(item, index) in uploadErrors' :key='index')
            | {{ item[0] }}
          v-card-text(style='overflow: auto;')
              v-data-table.elevation-0(
                :headers='headers'
                :items='tempList'
                :loading='uploading'
                hide-default-footer
                disable-pagination
              )
                template(v-slot:body.append='')
                  tr
                    td(colspan='6' align='right')
                      strong Total
                    td(align='right') {{ totalAmount.phpFormat() }}
                template(v-slot:item='row')
                  tr
                    td
                      v-tooltip(bottom='')
                        template(v-slot:activator='{ on, attrs }')
                          v-btn.mx-2(
                            text
                            dark
                            x-small
                            v-on='on'
                            color='red'
                            @click='deleteTempUnit(row.item.tempId)'
                          )
                            v-icon(dark='') mdi-delete
                        span Remove Stock
                    td {{ row.item.receipt_no }}
                    //- td {{ row.item.supplier_id }}-{{ row.item.stock_code  }}
                    td
                      small {{ row.item.product_name }}
                    td
                      small {{ row.item.brand_name }}
                    td(align='right') {{ (row.item.cost || 0).phpFormat() }}
                    td(align='right') {{ row.item.quantity }}
                    td(align='right') {{ (row.item.totalAmount || 0).phpFormat() }}
                    td.truncate
                      v-tooltip(bottom='')
                        template(v-slot:activator='{ on, attrs }')
                          span(v-on='on' v-bind='attrs') {{ dateFormat(row.item.date_recieved) }}
                        span {{ dateFormat(row.item.date_recieved) }}
</template>
<script>
import { moneyMixin } from '@/views/dashboard/mixins/helper.mixins'
import { mapState, mapActions } from 'vuex'
import indexKeyGenerator from '@/extra-functions/index-key-generator.extra'
import splrPdRepository from '@/repositories/supplier-product.repository'
import { apiVars } from '@/extra-functions/api-helper.extra'
import { errorHandler } from '@/extra-functions/store.extra'
import searchDelay from '@/extra-functions/searchDelay.extra'
import { isAxiosError } from 'axios'
import { ErrorPopup } from '@/lib/utils'
import { authAxios } from '@/extra-functions/axios.extra'

let searchSupplier = null

const stockDelay = searchDelay(1000)

function currentDate() {
  const date = new Date()
  const year = date.getFullYear()
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')

  return `${year}-${month}-${day}`
}

const inputVars = () => {
  return {
    notes: null,
    receiptNo: null,
    supplierId: null,
    searchInput: null,
    searching: false,
    cost: null,
    stockId: '',
    unit: '',
    unitSearchInput: null,
    quantity: null,
    dateTransaction: currentDate(),
    page: 1,
    itemsPerPage: 10,
    addingItem: false,
  }
}

export default {
  name: 'createRecievedInventories',
  data() {
    return {
      ...inputVars(),
      ...apiVars('splrPd'),
      filter: {},
      headers: [
        { text: 'Config', sortable: false },
        { text: 'Receipt No', sortable: false },
        // { text: 'Supplier-Stock ID', sortable: false },
        { text: 'Product Name', value: 'productName' },
        { text: 'Brand', value: 'brandName' },
        { text: 'Cost', value: 'cost' },
        { text: 'Quantity', value: 'quantity' },
        { text: 'Total Amount', value: 'totalAmount' },
        { text: 'Date' },
      ],
      console: console,
      tempUnits: [],
      panel: true,
    }
  },
  created() {
    this.fetchSuppliers({ index: 0, count: 10, search: '' })
    this.fetchAllUnits()
  },
  computed: {
    ...mapState({
      verifyErrors: (state) => state.recievedInventory.verifyErrors,
      verifying: (state) => state.recievedInventory.verifying,
      suppliers: (state) => state.supplier.list,
      tempList: (state) => state.recievedInventory.tempList,
      supplierFetching: (state) => state.supplier.fetching,
      supplierProductsUpdated: (state) => state.supplierProduct.channelUpdate,
      suppliersUpdated: (state) => state.supplier.channelUpdate,
      unitsUpdated: (state) => state.unit.channelUpdate,
      uploading: (state) => state.recievedInventory.storing,
      uploadSuccess: (state) => state.recievedInventory.storeSuccess,
      uploadErrors: (state) => state.recievedInventory.storeErrors,
      storeId: (state) => state.settings.storeId,
      units: (state) => state.unit.allList.map((unit) => unit.unit),
    }),
    selectedStock() {
      return this.splrPdList.find((e) => e.stock_id === this.stockId)
    },
    pageFirstIndex() {
      return (this.page - 1) * this.itemsPerPage
    },
    totalAmount() {
      return this.tempList.reduce((total, item) => total + item.totalAmount, 0)
    },
  },
  watch: {
    searchInput(val, old) {
      if (val === null) return
      this.searching = true
      clearTimeout(searchSupplier)
      searchSupplier = setTimeout(() => {
        this.searching = false
        // if (!val) val = old
        this.fetchSuppliers({
          index: 0,
          count: 10,
          search: val,
        })
      }, 500)
    },
    supplierId(val) {
      this.stockId = null
      this.getSplrPd()
    },
    selectedStock(val) {
      if (!val) return
      this.cost = this.selectedStock.cost
      this.unit = this.selectedStock.unit
    },
    supplierUpdated() {
      this.fetchSuppliers({ index: 0, count: 10, search: '' })
    },
    supplierProductsUpdated() {
      this.fetchSupplierProducts(this.supplierId)
    },
    // uploadSuccess(val) {
    //   if (val) {
    //     this.clearTempList()
    //   }
    // },
  },
  methods: {
    ...mapActions({
      fetchSuppliers: 'supplier/fetch',
      fetchAllUnits: 'unit/fetchAll',
      checkErrors: 'recievedInventory/checkErrors',
      // uploadData: 'recievedInventory/store',
      addTempItem: 'recievedInventory/addTempItem',
      removeTempItem: 'recievedInventory/removeTempItem',
      clearTempList: 'recievedInventory/clearTempList',
      setErrors: 'recievedInventory/setErrors',
    }),
    filterComboBox(item, queryText, itemText) {
      const regX = new RegExp(queryText, 'i')
      return regX.test(`${item.unit}${item.description}`)
    },
    getSplrPd() {
      this.splrPdLoading = true
      this.splrPdErrors = []
      stockDelay(() => {
        splrPdRepository
          .storeList(this.supplierId, this.storeId)
          .then(({ data }) => {
            this.splrPdList = data
          })
          .catch((e) => {
            this.splrPdErrors = errorHandler(e)
          })
          .then(() => {
            this.splrPdLoading = false
          })
      })
    },
    async initUpload() {
      try {
        const data = this.tempList.map((e) => {
          return {
            index_key: e.index_key,
            receipt_no: e.receipt_no,
            stock_id: e.stock_id,
            store_id: e.store_id,
            cost: e.cost,
            supplier_id: e.supplier_id,
            unit: e.unit,
            quantity: e.quantity,
            date_recieved: e.date_recieved,
            notes: e.notes,
          }
        })
        // this.uploadData(data)
        const axios = authAxios()
        await axios.post('/v2/purchases', { data })
        this.$emit('success')
        this.clearTempList()
      } catch (e) {
        if (isAxiosError(e) && e.status === 422) {
          this.setErrors(e.response.data)
          return
        }
        if (isAxiosError(e) && e.status === 500) {
          ErrorPopup.fire(
            'Server Error',
            'An error occurred while uploading the data. Please try again later.',
          )
          return
        }
        ErrorPopup.fire(
          'Error',
          'An unexpected error occurred. Please try again later.',
        )
      }
    },
    addTransaction() {
      const selectedStock = this.selectedStock
      const data = {
        index_key: indexKeyGenerator(),
        receipt_no: this.receiptNo,
        store_id: this.storeId,
        stock_id: this.stockId,
        cost: this.cost,
        supplier_id: this.supplierId,
        unit: this.unit,
        quantity: this.quantity,
        date_recieved: this.dateTransaction,
        notes: this.notes,
      }
      const addTempItem = this.addTempItem
      this.checkErrors({
        data,
        success(ret) {
          addTempItem({
            ...selectedStock,
            ...data,
            totalAmount: data.cost * data.quantity,
          })
        },
      })
    },
    dateFormat(ndate) {
      const date = new Date(ndate)
      const year = date.getFullYear()
      const month = `${date.getMonth() + 1}`.padStart(2, '0')
      const day = `${date.getDate()}`.padStart(2, '0')

      return `${month}/${day}/${year}`
    },
    deleteTempUnit(tempId) {
      this.removeTempItem(tempId)
    },
    filterSplrPd(item, queryText, itemText) {
      const rxQueryText = new RegExp(queryText, 'i')
      const itemSearch = `${item.brand_name.escapeRegExp()}|${item.product_name.escapeRegExp()}|${item.stock_code.escapeRegExp()}`
      return rxQueryText.test(itemSearch)
    },
  },
  mixins: [moneyMixin],
}
</script>
<style lang="scss" scoped>
.truncate {
  max-width: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
